// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3Fi6H","layout-grid":"_30Ruc","mini-story-card-grid":"_3IwN3"};